





























































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import VueMarkdown from 'vue-markdown-v2';
import Spinner from '@/components/Spinner.vue';
import Timer from '@/components/Timer.vue';
import ConnectionErrorContent from '@/components/ConnectionErrorContent.vue';

export interface Recipe {
	id: string;
    title: string;
    categories: Category[];
    ingredients: Ingredient[][];
    ingredientsTitle: string[];
    forValue: number;
    forType: string;
    directions: string;
    comments: string;
    images: string[];
    editedOn: string;
}

export interface Ingredient {
    quantity: string;
    unit: string;
    ingredient: string;
}

export interface Category {
    id: string;
    title: string;
    image: string;
}

export interface Nutrition {
    energy: number;
    energyKcal: number;
    fat: number;
    saturatedFat: number;
    carbohydrate: number;
    sugar: number;
    dietaryFiber: number;
    protein: number;
    salt: number; // sinnvoll?
}

@Component({
    components: {
        VueMarkdown,
        Spinner,
        Timer,
        ConnectionErrorContent,
    },
})
export default class ViewRecipe extends Vue {
    private status!: string;
    private recipe!: Recipe;
    private ingForValue!: number;
    private initialIngredients!: Ingredient[][];
    private modalTimerVisible!: boolean;
    private modalSpeechVisible!: boolean;
    private modalDeleteVisible!: boolean;
    private modalNutritionVisible!: boolean;
    private commentsHTML!: string;
    private directionsHTML!: string;
    private hasIngredientsTitle!: boolean[];
    private hasImage!: boolean;
    private hasComments!: boolean;
    private nutrition!: Nutrition;
    private overlay!: boolean;

    private data() {
        return {
            status: 'loading',
            recipe: {},
            ingForValue: +'',
            initialIngredients: [],
            modalTimerVisible: false,
            modalSpeechVisible: false,
            modalDeleteVisible: false,
            modalNutritionVisible: false,
            commentsHTML: '',
            directionsHTML: '',
            hasIngredientsTitle: [false, false, false, false],
            hasImage: false,
            hasComments: false,
            nutrition: {},
            overlay: false,
        };
    }

    private created() {
        this.loadData();
        window.addEventListener('keyup', (e) => {
            if (e.keyCode === 38) {
                if (this.ingForValue + 1 < 1000) {
                    this.ingForValue += 1;
                    this.changeIngValue();
                }
            } else if (e.keyCode === 40) {
                if (this.ingForValue - 1 > 0) {
                    this.ingForValue -= 1;
                    this.changeIngValue();
                }
            } else if (e.keyCode === 82) {
                this.showModalSpeech();
            } else if (e.keyCode === 84) {
                this.showModalTimer();
            }
        });
    }

    @Watch('$route', { immediate: true, deep: true })
    private onUrlChange(newVal: any) {
        this.loadData();
    }

    private loadData() {
        this.modalTimerVisible = false;
        this.modalSpeechVisible = false;
        this.modalDeleteVisible = false;
        this.modalNutritionVisible = false;
        this.overlay = false;
        this.status = 'loading';
        this.$store.state.mobileSidebarVisible = false;
        this.hasIngredientsTitle = [false, false, false, false];
        this.hasComments = false;
        this.hasImage = false;
        this.$http.get('recipes/get/' + this.$route.params.id).then((response: AxiosResponse) => {
            this.recipe = response.data;
            if (this.recipe.categories !== null) {
                this.recipe.categories = this.recipe.categories.sort((a, b) => a.title.localeCompare(b.title));
            } else {
                this.recipe.categories = [];
            }
            const d = new Date(this.recipe.editedOn);
            this.recipe.editedOn = d.toLocaleDateString(this.$store.state.personal.date, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
            this.ingForValue = this.recipe.forValue;
            if (response.data.images) {
                this.hasImage = true;
            }
            if (response.data.comments !== null && response.data.comments !== '') {
                this.hasComments = true;
            }
            for (let i = 0; i < response.data.ingredientsTitle.length; i++) {
                if (response.data.ingredientsTitle[i] !== '' && response.data.ingredientsTitle[i] !== null) {
                    this.hasIngredientsTitle[i] = true;
                }
            }
            for (let i = 0; i < this.recipe.ingredients.length; i++) {
                this.initialIngredients.push([]);
                for (let j = 0; j < this.recipe.ingredients[i].length; j++) {
                    this.initialIngredients[i].push(Object.assign({}, this.recipe.ingredients[i][j]));
                    this.initialIngredients[i][j].quantity = response.data.ingredients[i][j].quantity.replace(',', '.');
                }
            }
            this.changeIngValue();

            // Nutrition
            this.nutrition = {energy: 1619, energyKcal: 384, fat: 6.7, saturatedFat: 0.7, carbohydrate: 64, sugar: 3.1, dietaryFiber: 10, protein: 12, salt: 0.01};

            this.status = 'success';
        }).catch((error) => {
            if (error.response.status === 401) {
                this.status = 'notFound';
            } else {
                this.status = 'error';
            }
        });
    }

    private print() {
        window.print();
    }

    private changeIngValue() {
        if (this.ingForValue < 1000 && this.ingForValue > 0) {
            for (let i = 0; i < this.recipe.ingredients.length; i++) {
                for (let j = 0; j < this.recipe.ingredients[i].length; j++) {
                    if (!isNaN(parseFloat(this.initialIngredients[i][j].quantity))) {
                        const newQuantity = +this.initialIngredients[i][j].quantity * this.ingForValue / this.recipe.forValue;
                        this.recipe.ingredients[i][j].quantity = newQuantity.toLocaleString(this.$store.state.personal.lang, {maximumFractionDigits: 2});
                    }
                }
            }
        }
    }

    private showModalTimer() {
        if (this.modalTimerVisible === false) {
            this.modalTimerVisible = true;
            this.overlay = true;
        } else {
            this.modalTimerVisible = false;
            this.overlay = false;
        }
    }

    private showModalSpeech() {
        if (this.modalSpeechVisible === false) {
            this.modalSpeechVisible = true;
            this.overlay = true;
        } else {
            this.modalSpeechVisible = false;
            this.overlay = false;
        }
    }

    private showModalNutrition() {
        if (this.modalNutritionVisible === false) {
            this.modalNutritionVisible = true;
            this.overlay = true;
        } else {
            this.modalNutritionVisible = false;
            this.overlay = false;
        }
    }

    private showModalDelete() {
        if (this.modalDeleteVisible === false) {
            this.modalDeleteVisible = true;
            this.overlay = true;
        } else {
            this.modalDeleteVisible = false;
            this.overlay = false;
        }
    }

    private textToSpeech(a: string) {
        let text: string = '';
        if (a === 'ingredients') {
            for (let i = 0; i < this.recipe.ingredients.length; i++) {
                if (this.recipe.ingredientsTitle[i] !== '') {
                    text = text + this.recipe.ingredientsTitle[i] + ': ';
                }
                for (let j = 0; j < this.recipe.ingredients[i].length; j++) {
                    if (this.recipe.ingredients[i][j].quantity !== '') {
                        text = text + this.recipe.ingredients[i][j].quantity + ' ';
                    }
                    if (this.recipe.ingredients[i][j].unit !== '') {
                        text = text + this.recipe.ingredients[i][j].unit + ' ';
                    }
                    if (this.recipe.ingredients[i][j].ingredient !== '' && j < this.recipe.ingredients[i].length - 1) {
                        text = text + this.recipe.ingredients[i][j].ingredient + ', ';
                    }
                    if (this.recipe.ingredients[i][j].ingredient !== '' && j === this.recipe.ingredients[i].length - 1) {
                        text = text + this.recipe.ingredients[i][j].ingredient;
                    }
                }
            }
        } else if (a === 'directions') {
            text = this.recipe.directions;
        } else if (a === 'comments') {
            text = this.recipe.comments;
        }

        const voices = window.speechSynthesis.getVoices();
        const selectedVoices = [];
        for (let i = 0; i < voices.length; i++) {
            if (voices[i].lang === 'de') {
                selectedVoices.push(voices[i]);
            }
        }
        const toSpeak = new SpeechSynthesisUtterance(text);
        toSpeak.voice = selectedVoices[0];
        window.speechSynthesis.speak(toSpeak);
    }

    private deleteRecipe() {
        this.status = 'loading';
        this.$http.get('recipes/delete/' + this.$route.params.id).then((response: AxiosResponse) => {this.$store.state.recipeListStatus = 'loading';
            this.$store.dispatch('getRecipeList')
            .then((re) => {
                this.$store.state.recipeListShown = this.$store.state.recipeList.sort((a: any, b: any) => a.title.localeCompare(b.title));
                this.$store.state.recipeListStatus = 'success';
            }).catch((err) => {
                this.$store.state.recipeListStatus = 'error';
            });
            this.$router.push({ path: '/app/recipes'});
        }).catch((error) => {
            this.status = 'error';
        });   
    }
}
